/* tslint:disable */
/* eslint-disable */
/**
 * Optimizely Feature Experimentation API
 * This page documents how to use the Optimizely FX API. With this API you can view and manage Feature Flags and all of their related entities including Variables, Variations, Rules, and Reports.  The base URL is https://api.optimizely.com/flags/v1. Append any paths listed in these docs onto that url in order to make requests to the API.
 *
 * The version of the OpenAPI document: 0.3.7
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    PatchRequestBody,
    PatchRequestBodyFromJSON,
    PatchRequestBodyToJSON,
    ProblemDetail,
    ProblemDetailFromJSON,
    ProblemDetailToJSON,
    Ruleset,
    RulesetFromJSON,
    RulesetToJSON,
} from '../models';

export interface DisableRulesetRequest {
    project_id: number;
    flag_key: string;
    environment_key: string;
}

export interface EnableRulesetRequest {
    project_id: number;
    flag_key: string;
    environment_key: string;
}

export interface FetchRulesetRequest {
    project_id: number;
    flag_key: string;
    environment_key: string;
}

export interface UpdateRulesetRequest {
    project_id: number;
    flag_key: string;
    environment_key: string;
    patch_request_body: Array<PatchRequestBody>;
}

/**
 * no description
 */
export class RulesetsApi extends runtime.BaseAPI {

    /**
     * Disables the entire Ruleset for a Flag in an Environment
     * Disable the Ruleset for a Flag in an Environment
     */
    async disableRulesetRaw(requestParameters: DisableRulesetRequest): Promise<runtime.ApiResponse<Ruleset>> {
        if (requestParameters.project_id === null || requestParameters.project_id === undefined) {
            throw new runtime.RequiredError('project_id','Required parameter requestParameters.project_id was null or undefined when calling disableRuleset.');
        }

        if (requestParameters.flag_key === null || requestParameters.flag_key === undefined) {
            throw new runtime.RequiredError('flag_key','Required parameter requestParameters.flag_key was null or undefined when calling disableRuleset.');
        }

        if (requestParameters.environment_key === null || requestParameters.environment_key === undefined) {
            throw new runtime.RequiredError('environment_key','Required parameter requestParameters.environment_key was null or undefined when calling disableRuleset.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/projects/{project_id}/flags/{flag_key}/environments/{environment_key}/ruleset/disabled`.replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.project_id))).replace(`{${"flag_key"}}`, encodeURIComponent(String(requestParameters.flag_key))).replace(`{${"environment_key"}}`, encodeURIComponent(String(requestParameters.environment_key))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => RulesetFromJSON(jsonValue));
    }

    /**
     * Disables the entire Ruleset for a Flag in an Environment
     * Disable the Ruleset for a Flag in an Environment
     */
    async disableRuleset(requestParameters: DisableRulesetRequest): Promise<Ruleset> {
        const response = await this.disableRulesetRaw(requestParameters);
        return await response.value();
    }

    /**
     * Enables the entire Ruleset for a Flag in an Environment
     * Enable the Ruleset for a Flag in an Environment
     */
    async enableRulesetRaw(requestParameters: EnableRulesetRequest): Promise<runtime.ApiResponse<Ruleset>> {
        if (requestParameters.project_id === null || requestParameters.project_id === undefined) {
            throw new runtime.RequiredError('project_id','Required parameter requestParameters.project_id was null or undefined when calling enableRuleset.');
        }

        if (requestParameters.flag_key === null || requestParameters.flag_key === undefined) {
            throw new runtime.RequiredError('flag_key','Required parameter requestParameters.flag_key was null or undefined when calling enableRuleset.');
        }

        if (requestParameters.environment_key === null || requestParameters.environment_key === undefined) {
            throw new runtime.RequiredError('environment_key','Required parameter requestParameters.environment_key was null or undefined when calling enableRuleset.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/projects/{project_id}/flags/{flag_key}/environments/{environment_key}/ruleset/enabled`.replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.project_id))).replace(`{${"flag_key"}}`, encodeURIComponent(String(requestParameters.flag_key))).replace(`{${"environment_key"}}`, encodeURIComponent(String(requestParameters.environment_key))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => RulesetFromJSON(jsonValue));
    }

    /**
     * Enables the entire Ruleset for a Flag in an Environment
     * Enable the Ruleset for a Flag in an Environment
     */
    async enableRuleset(requestParameters: EnableRulesetRequest): Promise<Ruleset> {
        const response = await this.enableRulesetRaw(requestParameters);
        return await response.value();
    }

    /**
     * Fetch a Ruleset for a Flag in a specific Environment of a project.  The Ruleset contains the set of all Rules that apply to the Flag for that Environment. 
     * Fetch the Ruleset for a Flag in an Environment
     */
    async fetchRulesetRaw(requestParameters: FetchRulesetRequest): Promise<runtime.ApiResponse<Ruleset>> {
        if (requestParameters.project_id === null || requestParameters.project_id === undefined) {
            throw new runtime.RequiredError('project_id','Required parameter requestParameters.project_id was null or undefined when calling fetchRuleset.');
        }

        if (requestParameters.flag_key === null || requestParameters.flag_key === undefined) {
            throw new runtime.RequiredError('flag_key','Required parameter requestParameters.flag_key was null or undefined when calling fetchRuleset.');
        }

        if (requestParameters.environment_key === null || requestParameters.environment_key === undefined) {
            throw new runtime.RequiredError('environment_key','Required parameter requestParameters.environment_key was null or undefined when calling fetchRuleset.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/projects/{project_id}/flags/{flag_key}/environments/{environment_key}/ruleset`.replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.project_id))).replace(`{${"flag_key"}}`, encodeURIComponent(String(requestParameters.flag_key))).replace(`{${"environment_key"}}`, encodeURIComponent(String(requestParameters.environment_key))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => RulesetFromJSON(jsonValue));
    }

    /**
     * Fetch a Ruleset for a Flag in a specific Environment of a project.  The Ruleset contains the set of all Rules that apply to the Flag for that Environment. 
     * Fetch the Ruleset for a Flag in an Environment
     */
    async fetchRuleset(requestParameters: FetchRulesetRequest): Promise<Ruleset> {
        const response = await this.fetchRulesetRaw(requestParameters);
        return await response.value();
    }

    /**
     * Update the Ruleset for a Flag in a specific Environment of a project using a json patch structure. Properties that are read only that are present in the request body will be ignored as well as unknown properties. 
     * Update the Ruleset for a Flag in an Environment
     */
    async updateRulesetRaw(requestParameters: UpdateRulesetRequest): Promise<runtime.ApiResponse<Ruleset>> {
        if (requestParameters.project_id === null || requestParameters.project_id === undefined) {
            throw new runtime.RequiredError('project_id','Required parameter requestParameters.project_id was null or undefined when calling updateRuleset.');
        }

        if (requestParameters.flag_key === null || requestParameters.flag_key === undefined) {
            throw new runtime.RequiredError('flag_key','Required parameter requestParameters.flag_key was null or undefined when calling updateRuleset.');
        }

        if (requestParameters.environment_key === null || requestParameters.environment_key === undefined) {
            throw new runtime.RequiredError('environment_key','Required parameter requestParameters.environment_key was null or undefined when calling updateRuleset.');
        }

        if (requestParameters.patch_request_body === null || requestParameters.patch_request_body === undefined) {
            throw new runtime.RequiredError('patch_request_body','Required parameter requestParameters.patch_request_body was null or undefined when calling updateRuleset.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        const response = await this.request({
            path: `/projects/{project_id}/flags/{flag_key}/environments/{environment_key}/ruleset`.replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.project_id))).replace(`{${"flag_key"}}`, encodeURIComponent(String(requestParameters.flag_key))).replace(`{${"environment_key"}}`, encodeURIComponent(String(requestParameters.environment_key))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.patch_request_body.map(PatchRequestBodyToJSON),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => RulesetFromJSON(jsonValue));
    }

    /**
     * Update the Ruleset for a Flag in a specific Environment of a project using a json patch structure. Properties that are read only that are present in the request body will be ignored as well as unknown properties. 
     * Update the Ruleset for a Flag in an Environment
     */
    async updateRuleset(requestParameters: UpdateRulesetRequest): Promise<Ruleset> {
        const response = await this.updateRulesetRaw(requestParameters);
        return await response.value();
    }

}
